import ClientService from '../../services/client-service';
import LocalStorageService from '../../services/local-storage-service';
import {
  GET_BASE_DATA, GET_BASE_DATA_SUCCESS, GET_BASE_DATA_ERROR, SAVE_USER_DATA_SUCCESS, DELETE_NOTIFICATION_SUCCESS,
  DELETE_ALL_NOTIFICATIONS_SUCCESS, COMMENT_ADDED_SUCCESS, NOTIFICATION_ADDED_SUCCESS, SAVE_PROFILE_SETTINGS_SUCCESS,
  SAVE_TABLE_COLUMN_SETTINGS_SUCCESS, READ_NOTIFICATIONS_SUCCESS, READ_COMMENTS_SUCCESS, RESET_FEED_DATA,
  DELETE_FEED_ITEM, GET_COMMENT_LIST_DATA_SUCCESS, GET_NOTIFICATION_LIST_DATA_SUCCESS, GET_DEAL_DATA_SUCCESS,
  LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS, VERIFY_USER_SUCCESS, USER_SESSION_EXPIRED_SUCCESS, RESET_BASE_DATA,
  RESET_USER_SETTINGS_SUCCESS, CHANGE_PASSWORD_SUCCESS, SAVE_WIDGET_SETTINGS_SUCCESS, IMPORT_USER_SETTINGS_SUCCESS,
  USER_SESSION_EXPIRED_SUBSCRIBED_SUCCESS, SAVE_ACCOUNT_SETTINGS_SUCCESS, RESET_APP_LOADER,
  SAVE_USER_PUSH_NOTIFICATION_TOKEN_SUCCESS, SAVE_USER_VERIFICATION_DATA_SUCCESS,
} from '../../constants/system/actions';
import { HTTP_CODE_LIST_USER_ERRORS } from '../../constants/system/http-codes';

const appReducer: Reducer = (
  state: ReducerState = {
    baseData: null,
    feedData: [],
    isLoading: true,
    isServerFault: false,
    isUserSessionExpired: false,
    userSessionExpiredActiveSubscription: null,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_BASE_DATA:
      return {
        ...state,
        isLoading: true,
      };
    case GET_BASE_DATA_SUCCESS:
      return {
        ...state,
        baseData: action.data,
        isServerFault: false,
        isLoading: false,
      };
    case GET_BASE_DATA_ERROR:
      return {
        ...state,
        isServerFault: action.error && (
          !action.error.graphQLErrors || !action.error.graphQLErrors[0]
          || !action.error.graphQLErrors[0].statusCode
          || !HTTP_CODE_LIST_USER_ERRORS.includes(action.error.graphQLErrors[0].statusCode)
        ),
        isLoading: false,
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
    case SAVE_USER_DATA_SUCCESS:
      return {
        ...state,
        baseData: {
          currentUser: action.data.user,
        },
        feedData: [],
        isServerFault: false,
        isUserSessionExpired: false,
        userSessionExpiredActiveSubscription: null,
      };
    case VERIFY_USER_SUCCESS:
    case CHANGE_PASSWORD_SUCCESS:
    case SAVE_USER_VERIFICATION_DATA_SUCCESS:
      if (action.data.user) {
        return {
          ...state,
          baseData: {
            currentUser: action.data.user,
          },
          feedData: [],
          isUserSessionExpired: false,
        };
      }

      return state;
    case SAVE_PROFILE_SETTINGS_SUCCESS:
      return {
        ...state,
        baseData: {
          ...state.baseData,
          currentUser: action.data.settingsData && action.data.settingsData.profileSettingsData,
        },
      };
    case SAVE_ACCOUNT_SETTINGS_SUCCESS:
      return {
        ...state,
        baseData: {
          ...state.baseData,
          currentUser: {
            ...state.baseData.currentUser,
            account: {
              ...state.baseData.currentUser.account,
              name: action.data.settingsData.accountData ? action.data.settingsData.accountData.name
                : state.baseData.currentUser.account.name,
              photo: action.data.settingsData.accountData ? action.data.settingsData.accountData.photo
                : state.baseData.currentUser.account.photo,
              photoThumbnail: action.data.settingsData.accountData ? action.data.settingsData.accountData.photoThumbnail
                : state.baseData.currentUser.account.photoThumbnail,
              settings: action.data.settingsData.accountData ? action.data.settingsData.accountData.settings
                : state.baseData.currentUser.account.settings,
            },
          },
        },
      };
    case RESET_USER_SETTINGS_SUCCESS:
    case IMPORT_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        baseData: {
          ...state.baseData,
          currentUser: action.data.settingsData && action.data.settingsData.profileSettingsData
          && action.data.settingsData.profileSettingsData.id === state.baseData.currentUser
            ? action.data.settingsData.profileSettingsData : state.baseData.currentUser,
        },
      };
    case DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        baseData: {
          ...state.baseData,
          notifications: action.data.notifications,
        },
      };
    case DELETE_ALL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        baseData: {
          ...state.baseData,
          notifications: action.data.notifications,
        },
      };
    case NOTIFICATION_ADDED_SUCCESS:
      if (state.baseData && state.baseData.notifications) {
        return {
          ...state,
          baseData: {
            ...state.baseData,
            notifications: action.data ? [action.data, ...state.baseData.notifications] : state.baseData.notifications,
            newNotificationsTotal: action.data ? state.baseData.newNotificationsTotal + 1
              : state.baseData.newNotificationsTotal,
          },
          feedData: action.data ? [...state.feedData, action.data] : state.feedData,
        };
      }

      return state;
    case COMMENT_ADDED_SUCCESS:
      if (state.baseData && state.baseData.comments) {
        return {
          ...state,
          baseData: {
            ...state.baseData,
            comments: action.data ? [action.data, ...state.baseData.comments] : state.baseData.comments,
            newCommentsTotal: action.data ? state.baseData.newCommentsTotal + 1 : state.baseData.newCommentsTotal,
          },
        };
      }

      return state;
    case SAVE_TABLE_COLUMN_SETTINGS_SUCCESS:
      return {
        ...state,
        baseData: {
          ...state.baseData,
          currentUser: {
            ...state.baseData.currentUser,
            settings: action.data.currentUserSettings,
          },
        },
      };
    case SAVE_WIDGET_SETTINGS_SUCCESS:
      return {
        ...state,
        baseData: {
          ...state.baseData,
          currentUser: {
            ...state.baseData.currentUser,
            settings: action.data.currentUserSettings,
          },
        },
      };
    case READ_NOTIFICATIONS_SUCCESS:
      if (state.baseData && state.baseData.notifications) {
        return {
          ...state,
          baseData: {
            ...state.baseData,
            newNotificationsTotal: 0,
          },
        };
      }

      return state;
    case READ_COMMENTS_SUCCESS:
      if (state.baseData && state.baseData.comments) {
        return {
          ...state,
          baseData: {
            ...state.baseData,
            newCommentsTotal: 0,
          },
        };
      }

      return state;
    case DELETE_FEED_ITEM:
      if (state.feedData) {
        return {
          ...state,
          feedData: state.feedData.map((contentItem: ContentItem): ContentItem | null => (
            contentItem.id === action.payload.id && contentItem.type === action.payload.type ? null : contentItem
          )).filter((contentItem: ContentItem): boolean => !!contentItem),
        };
      }

      return state;
    case RESET_BASE_DATA:
      return {
        ...state,
        baseData: null,
        feedData: [],
        isLoading: false,
        isServerFault: false,
        isUserSessionExpired: false,
        userSessionExpiredActiveSubscription: null,
      };
    case RESET_APP_LOADER:
      return {
        ...state,
        isLoading: false,
      };
    case RESET_FEED_DATA:
      return {
        ...state,
        feedData: [],
      };
    case GET_COMMENT_LIST_DATA_SUCCESS:
      if (action.payload && action.payload.page) {
        return {
          ...state,
          baseData: {
            ...state.baseData,
            comments: [...state.baseData.comments, ...action.data.commentList],
          },
        };
      }

      return {
        ...state,
        baseData: {
          ...state.baseData,
          comments: action.data.commentList,
          newCommentList: action.data.commentList,
          commentsTotal: action.data.commentsTotal,
        },
      };
    case GET_NOTIFICATION_LIST_DATA_SUCCESS:
      if (action.payload && action.payload.page) {
        return {
          ...state,
          baseData: {
            ...state.baseData,
            notifications: [...state.baseData.notifications, ...action.data.notificationList],
          },
        };
      }

      return {
        ...state,
        baseData: {
          ...state.baseData,
          notifications: action.data.notificationList,
          newNotificationList: action.data.notificationList,
          notificationsTotal: action.data.notificationsTotal,
        },
      };
    case GET_DEAL_DATA_SUCCESS:
      return {
        ...state,
        baseData: {
          ...state.baseData,
          comments: action.data.commentList,
          newCommentList: action.data.commentList,
          commentsTotal: action.data.commentsTotal,
          notifications: action.data.notificationList,
          newNotificationList: action.data.notificationList,
          notificationsTotal: action.data.notificationsTotal,
        },
      };
    case SAVE_USER_PUSH_NOTIFICATION_TOKEN_SUCCESS:
      if (action.data.success && action.payload.token) {
        LocalStorageService.setPushNotificationToken(action.payload.token);
      }

      return state;
    case USER_SESSION_EXPIRED_SUCCESS:
      ClientService.closeConnections();

      return {
        ...state,
        isUserSessionExpired: action.data && !!action.data.success,
      };
    case USER_SESSION_EXPIRED_SUBSCRIBED_SUCCESS:
      return {
        ...state,
        userSessionExpiredActiveSubscription: action.subscription,
      };
    default:
      return state;
  }
};

export default appReducer;
